import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faGraduationCap, faVideo, faLightbulb, faBell } from '@/fontawesome';
import { ALL_EMAIL_OPT_OUT_KEYS, EMAIL_OPT_OUT_LABELS, type UserEmailOptOut, type UserEmailOptOutKey } from '@/models';

export const EMAIL_OPT_OUT_ICONS: Record<UserEmailOptOutKey, IconProp> = {
  courseMailSequence: faGraduationCap,
  videoPublished: faVideo,
  recommendationMails: faLightbulb,
  eventReminder: faBell,
};

interface EmailOptOutIconsProps {
  emailOptOut: UserEmailOptOut;
}

export default function EmailOptOutIcons({ emailOptOut }: EmailOptOutIconsProps) {
  return (
    <div className="flex items-center space-x-2">
      {ALL_EMAIL_OPT_OUT_KEYS.map((key) => {
        const optedOut = emailOptOut[key];
        return (
          <div key={key} className="relative group">
            <div className={`w-7 h-7 rounded flex items-center justify-center ${optedOut ? 'bg-red-100 dark:bg-red-900/30' : 'bg-green-100 dark:bg-green-900/30'}`}>
              <FontAwesomeIcon
                icon={EMAIL_OPT_OUT_ICONS[key]}
                className={`w-3.5 h-3.5 ${optedOut ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'}`}
              />
            </div>
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity whitespace-nowrap z-10">
              {EMAIL_OPT_OUT_LABELS[key]}: {optedOut ? 'Abgemeldet' : 'Aktiv'}
            </div>
          </div>
        );
      })}
    </div>
  );
}
